
import React from "react";

const DailyPlanner = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Daily Planner</h1>
      <p className="text-gray-600">Coming soon! Plan your daily activities here.</p>
    </div>
  );
};

export default DailyPlanner;
